import React, { Component } from 'react';

import Config from './../config/Config';
import WidgetAjax from './../widget/WidgetAjax';
import WidgetModal from '../widget/WidgetModal';
import EventBus from './eventBus';

import LocationPicker from './LocationPicker';

const mapPath = Config.getAMapPath();

class Location extends React.Component {

    constructor(props) {
        super(props);

        let location = sessionStorage.getItem("_user_location_") || "{}";

        if (location) {
            location = JSON.parse(location);
        }

        this.state = {
            location: location.value || "100000",
            locationName: location.name || "全国",
            modalOptions: {
                title: "",
                confirm: "确定",
                width: 890,
                isOk: false,
                isLast: false,
                isNext: false,
                isCancel: false
            }
        }
    }

    componentDidMount() {
        this.getIpService();
        this.initLocation();
    }

    /**
     * 获取ip
     */
    getIpService = async () => {
        try {
            const response = await fetch('https://ipapi.co/json/'); // 支持CORS
            if (!response.ok) throw new Error('请求失败');

            const data = await response.json();
            await this.setState({
                ipService: {
                    ip: data.ip,          // 公网IP（如 113.xx.xx.xx）
                    city: data.city,      // 城市（如 上海）
                    region: data.region,  // 省份（如 上海市）
                    country: data.country // 国家（如 CN）
                }
            })
            this.initLocation(data.ip);
        } catch (error) {
            console.error('获取IP失败：', error);
            this.locationNotify(this.state.location);
        }
    }

    initLocation = (ip) => {
        let { location, locationName } = this.state;
        const onLoadLocation = async (result, params) => {
            if (result.status === 0) {
               
                if (result.status == 0) {
                    if (result?.content && result?.content?.address_detail) {
                        let obj = result?.content?.address_detail;
                        location = obj.adcode;
                        locationName = obj.city;
                    }
                    await this.setState({ location: location, locationName: locationName });
                   
                }
                // if (result.result && result.result.ad_info) {
                //     location = result.result.ad_info.adcode;
                //     locationName = result.result.ad_info.city;
                // }
            }
          
            this.locationNotify(location);
        }

        WidgetAjax.ajax({ url: mapPath + "?ak=" + Config.getAMapKey() + "&ip=" + ip + "&coor=bd09ll", params: undefined, callback: onLoadLocation })
    }

    changeLocation = () => {

        this.modalRef.open();
    }

    changeLocationHandle = () => {
        this.modalRef.onClose();
    }

    locationNotify = (location, onOpen) => {
        sessionStorage.setItem("_user_location_", JSON.stringify(location));

        EventBus.emit('locationChange', location);

        // if( location.value!=="110000" )
        // {
        //     EventBus.emit('locationChange', location);
        // }
        // else
        // {
        //     EventBus.emit('locationChange', {value:undefined, name:undefined});
        // }

        if (!onOpen) {
            this.modalRef.onClose();
        }

        this.setState({ locationName: location.name, location: location.value });

    }

    render() {
        const { locationName, modalOptions } = this.state;

        return (
            <>
                <div className="sf-location" style={{ float: 'left' }} >
                    <img className="headimg" src={require('../img/frame/location.svg')} alt="es-lint want to get"></img>
                    <span style={{ paddingTop: '10px', fontSize: '14px' }}>{locationName}</span>
                    【<a onClick={this.changeLocation}>切换</a>】
                </div>

                <WidgetModal options={modalOptions} isHide={true} onRef={ref => this.modalRef = ref} onOk={() => this.changeLocationHandle()} >
                    <LocationPicker notify={this.locationNotify}></LocationPicker>
                </WidgetModal>
            </>

        )
    }

}

export default Location